import styled from "styled-components";




export const ShapeContainer = styled.div`
    position: absolute;
    background-repeat: no-repeat;
    border: solid;
    opacity: 0;
    ${props => props.effectType === 'backdrop' && !props.hasCustomShape ? `backdrop-filter: blur(${props.glassEffect}px) invert(${props.invertEffect}) grayscale(${props.grayscaleEffect});` : `filter: blur(${props.effectType === 'backdrop' ? 0 : props.blur}px);`}
`
    // /* left: ${props => props.position.x}px;
    // top: ${props => props.position.y}px;
    // z-index: ${props => props.zIndex}; */

    // /* width: ${props => props.width}px;
    // height: ${props => props.height}px; */
    // /* background-color: ${props => props.backgroundColor}; */
    // /* background: ${props => {
    //     if (props.backgroundColor.type === 'color') {
    //         return props.backgroundColor.colorValue;
    //     } else {
    //         let gradient = '';
    //         props.backgroundColor.gradientLayers.map((layer, index) => {
    //             gradient = `linear-gradient(${layer.angle}deg, ${layer.firstColor}, ${layer.secondColor} ${layer.transition}%)` + gradient
    //             if (index != props.backgroundColor.gradientLayers.length - 1) {
    //                 gradient = ', ' + gradient
    //             }
    //         })

    //         return gradient
    //     }
    // }}; */
export const ShapeStyle = styled.div`
   

`
    // /* border-color: ${props => props.borderColor};
    // border-width: ${props => props.borderWidth}px;
    // border-top-left-radius: ${props => props.borderRadius.leftTop}px;
    // border-top-right-radius: ${props => props.borderRadius.rightTop}px;
    // border-bottom-left-radius: ${props => props.borderRadius.leftBottom}px;
    // border-bottom-right-radius: ${props => props.borderRadius.rightBottom}px;
    // box-shadow: ${props => props.shadow}; */
